import { LegalTable } from 'features/legal-documents/components/legal-table/legal-table';
import { LegalTopBar } from 'features/legal-documents/components/top-bar/legal-top-bar';
import { UploadDocumentsLegalModal } from 'features/legal-documents/components/top-bar/upload-documents-legal';
import { UploadDocumentsLegalItemModal } from 'features/legal-documents/components/top-bar/upload-Documents-legal-items';
import { useGetLegalList } from 'features/legal-documents/use-cases/get-legal';
import { useUserContext } from 'features/users';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

export const LegalDocumentsView = () => {
  const { menuItem, user, companyUser } = useUserContext();
  const { data, isLoading, refetch } = useGetLegalList(user?.CompanyId);
  const [titleDocuments, setTitleDocuments] = useState('');
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [showUploadModal, setShowUploadModal] = useState(false);
  useEffect(() => {
    if (!menuItem?.rc?.length) return;
    const legalDocumentItem = menuItem.rc.find(
      (item: any) => item.Name === 'Legal Documents',
    );
    const redirectUrl =
      legalDocumentItem?.Url || menuItem.rc[0]?.Url || 'dashboard';
    navigate(`/${redirectUrl}`);
  }, [menuItem?.rc, navigate]);
  useEffect(() => {
    if (!companyUser?.rc || companyUser.rc.length === 0) {
      navigate('/no-company'); // Redirect to "not found" route
    }
  }, [companyUser?.rc, navigate]);

  return (
    <>
      <LegalTopBar />

      <LegalTable
        dataList={data?.rc as any}
        isLoading={isLoading}
        setTitleDocuments={setTitleDocuments}
        setShowModal={setShowModal}
        setShowUploadModal={setShowUploadModal}
        refetch={refetch}
        // tableParams={params}
        // updateParams={updateParams}
      />
      {showModal && (
        <UploadDocumentsLegalModal
          onClose={() => setShowModal(false)}
          titleDocuments={titleDocuments}
          refetch={refetch}
        />
      )}
      {showUploadModal && (
        <UploadDocumentsLegalItemModal
          onClose={() => setShowUploadModal(false)}
          refetch={refetch}
        />
      )}
      <Outlet />
    </>
  );
};
